import ProposalRedirection from './ProposalRedirection';

export default ProposalRedirection;
